export default __webpack_public_path__ + "static/media/Vax-Track-2.cb0fbe13.jpg";